[
  {
    "id": "SR-B6-BOMEN-V01",
    "module": "SpellingRegel",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "skill": "klanken_spelling",
    "subSkill": "lange_klank",
    "familyId": "SR-LANGE-KLANK-OPEN",
    "conceptId": "open_syllable_single_vowel",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["bomen", "boomen", "bomenn", "boome"],
    "correctAnswer": 0,
    "explanation": "Lange klank aan het eind van een klankgroep (bo-men)? Dan schrijf je maar één klinker. Je hoort 'oo', maar in een open lettergreep schrijf je één 'o'.",
    "distractorExplanations": {
      "1": "Je hoort 'oo', maar in een open lettergreep (bo-men) schrijf je maar één klinker.",
      "2": "Het woord eindigt op '-en', niet op '-enn'. Er is geen dubbele 'n' nodig.",
      "3": "Het meervoud eindigt op '-en', niet op '-e'. Bomen, niet boome."
    }
  },
  {
    "id": "SR-B6-POTTEN-V01",
    "module": "SpellingRegel",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "skill": "klanken_spelling",
    "subSkill": "korte_klank",
    "familyId": "SR-KORTE-KLANK-GESLOTEN",
    "conceptId": "closed_syllable_double_consonant",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["potten", "poten", "potenn", "pootten"],
    "correctAnswer": 0,
    "explanation": "Korte klank in een gesloten lettergreep (pot-ten)? Dan verdubbel je de medeklinker. De 'o' is kort, dus dubbele 't'.",
    "distractorExplanations": {
      "1": "'Poten' zijn de poten van een dier (lange 'o'). Voor de korte 'o' van een pot heb je dubbele 't' nodig: pot-ten.",
      "2": "Het woord eindigt op '-en', niet op '-enn'. Alleen de medeklinker verdubbelt, niet de 'n'.",
      "3": "De klinker 'o' verdubbelt niet — de medeklinker 't' verdubbelt. Het is pot-ten, niet poot-ten."
    }
  },
  {
    "id": "SR-B6-LIEVE-V01",
    "module": "SpellingRegel",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "skill": "klanken_spelling",
    "subSkill": "v_f_wissel",
    "familyId": "SR-V-F-WISSEL",
    "conceptId": "v_f_alternation",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: een ... hond.",
    "options": ["lieve", "liefve", "liefe", "lief"],
    "correctAnswer": 0,
    "explanation": "'Lief' eindigt op een 'f'. Maar als je het woord langer maakt, wordt de 'f' een 'v': lieve. Dit heet de v/f-wisseling.",
    "distractorExplanations": {
      "1": "De 'f' verandert helemaal in een 'v'. Je schrijft niet beide letters samen.",
      "2": "De 'f' verandert in een 'v', niet in een andere 'f'. Het is lieve, niet liefe.",
      "3": "'Lief' is de korte vorm. Met '-e' erachter wordt het 'lieve' (de f wordt v)."
    }
  },
  {
    "id": "SR-B6-HUIZEN-V01",
    "module": "SpellingRegel",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "skill": "klanken_spelling",
    "subSkill": "s_z_wissel",
    "familyId": "SR-S-Z-WISSEL",
    "conceptId": "s_z_alternation",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: twee ...",
    "options": ["huizen", "huisen", "huissen", "huizzen"],
    "correctAnswer": 0,
    "explanation": "'Huis' eindigt op een 's'. Maar als je het woord langer maakt, wordt de 's' een 'z': huizen. Dit heet de s/z-wisseling.",
    "distractorExplanations": {
      "1": "De 's' verandert in een 'z' als je het woord langer maakt. Huis → huizen.",
      "2": "Er is geen dubbele 's' nodig. De 's' verandert gewoon in een 'z'.",
      "3": "Er is geen dubbele 'z' nodig. Eén 'z' is genoeg: huizen."
    }
  },
  {
    "id": "SR-B6-HOND-V01",
    "module": "SpellingRegel",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "skill": "klanken_spelling",
    "subSkill": "eind_d_t",
    "familyId": "SR-EIND-D-T",
    "conceptId": "final_d_t_check",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["hond", "hont", "honnt", "hontd"],
    "correctAnswer": 0,
    "explanation": "Twijfel je tussen d of t? Maak het woord langer: honden. Je hoort een 'd', dus schrijf je 'hond' met een 'd'.",
    "distractorExplanations": {
      "1": "Maak het langer: hon-den. Je hoort een 'd', dus het is 'hond', niet 'hont'.",
      "2": "Er is geen dubbele 'n' nodig, en het eindigt op 'd', niet 't'.",
      "3": "Dit is geen bestaande spelling. Het is gewoon 'hond'."
    }
  },
  {
    "id": "SR-B6-LOPEN-V01",
    "module": "SpellingRegel",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "skill": "klanken_spelling",
    "subSkill": "lange_klank",
    "familyId": "SR-LANGE-KLANK-OPEN",
    "conceptId": "open_syllable_single_vowel",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["lopen", "loopen", "lopenn", "loope"],
    "correctAnswer": 0,
    "explanation": "Lange klank in een open lettergreep (lo-pen): je hoort 'oo', maar schrijft maar één 'o'. Dit is dezelfde regel als bij 'bomen'.",
    "distractorExplanations": {
      "1": "In een open lettergreep (lo-pen) schrijf je maar één klinker, ook al hoor je 'oo'.",
      "2": "Geen dubbele 'n' aan het eind. Het meervoud/de stam eindigt gewoon op '-en'.",
      "3": "Het woord eindigt op '-en', niet op '-e'."
    }
  },
  {
    "id": "SR-B6-BAKKEN-V01",
    "module": "SpellingRegel",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "skill": "klanken_spelling",
    "subSkill": "korte_klank",
    "familyId": "SR-KORTE-KLANK-GESLOTEN",
    "conceptId": "closed_syllable_double_consonant",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["bakken", "baken", "bakkenn", "baaken"],
    "correctAnswer": 0,
    "explanation": "Korte klank (bak-ken): de 'a' is kort, dus de medeklinker 'k' verdubbelt. Let op: 'baken' is een ander woord (een licht op zee)!",
    "distractorExplanations": {
      "1": "'Baken' is een ander woord (een lichtsignaal op zee). Voor het werkwoord 'bakken' heb je dubbele 'k' nodig.",
      "2": "Alleen de medeklinker verdubbelt, niet de 'n' aan het eind.",
      "3": "De klinker 'a' verdubbelt niet — de medeklinker 'k' verdubbelt. De 'a' is juist kort."
    }
  },
  {
    "id": "SR-B6-BRAVE-V01",
    "module": "SpellingRegel",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "skill": "klanken_spelling",
    "subSkill": "v_f_wissel",
    "familyId": "SR-V-F-WISSEL",
    "conceptId": "v_f_alternation",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: een ... kat.",
    "options": ["brave", "brafve", "brafe", "braaf"],
    "correctAnswer": 0,
    "explanation": "'Braaf' eindigt op een 'f'. Met '-e' erachter wordt de 'f' een 'v': brave. Dezelfde regel als bij lief → lieve.",
    "distractorExplanations": {
      "1": "De 'f' wordt volledig vervangen door een 'v'. Je schrijft niet 'fv' samen.",
      "2": "De 'f' verandert in een 'v', niet in een andere 'f'. Het is brave, niet brafe.",
      "3": "'Braaf' is de korte vorm. Met '-e' erachter wordt het 'brave'."
    }
  },
  {
    "id": "SR-B6-GLAZEN-V01",
    "module": "SpellingRegel",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "skill": "klanken_spelling",
    "subSkill": "s_z_wissel",
    "familyId": "SR-S-Z-WISSEL",
    "conceptId": "s_z_alternation",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: twee ...",
    "options": ["glazen", "glasen", "glassen", "glazzen"],
    "correctAnswer": 0,
    "explanation": "'Glas' eindigt op een 's'. In het meervoud wordt de 's' een 'z': glazen. Dezelfde regel als bij huis → huizen.",
    "distractorExplanations": {
      "1": "De 's' verandert in een 'z'. Glas → glazen, net als huis → huizen.",
      "2": "Geen dubbele 's'. De 's' verandert gewoon in een 'z'.",
      "3": "Geen dubbele 'z'. Eén 'z' is genoeg: glazen."
    }
  },
  {
    "id": "SR-B6-HARD-V01",
    "module": "SpellingRegel",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "skill": "klanken_spelling",
    "subSkill": "eind_d_t",
    "familyId": "SR-EIND-D-T",
    "conceptId": "final_d_t_check",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["hard", "hart", "harrd", "hardt"],
    "correctAnswer": 0,
    "explanation": "Maak het langer: harde. Je hoort een 'd', dus schrijf je 'hard'. Let op: 'hart' is het orgaan in je borst — een ander woord!",
    "distractorExplanations": {
      "1": "'Hart' is het orgaan in je borst. 'Hard' (stevig) schrijf je met een 'd'. Verleng: har-de.",
      "2": "Er is geen dubbele 'r' nodig in dit woord.",
      "3": "'Hardt' bestaat niet. Het is gewoon 'hard' (verleng: harde)."
    }
  },
  {
    "id": "SR-B6-REGEN-V01",
    "module": "SpellingRegel",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "skill": "klanken_spelling",
    "subSkill": "lange_klank",
    "familyId": "SR-LANGE-KLANK-OPEN",
    "conceptId": "open_syllable_single_vowel",
    "variantIndex": 3,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["regen", "reegen", "regenn", "reegen"],
    "correctAnswer": 0,
    "explanation": "Lange klank in een open lettergreep (re-gen): je hoort 'ee', maar schrijft maar één 'e'.",
    "distractorExplanations": {
      "1": "In een open lettergreep schrijf je maar één klinker, ook al hoor je 'ee'.",
      "2": "Geen dubbele 'n' aan het eind.",
      "3": "Zelfde als optie B: in een open lettergreep schrijf je maar één klinker."
    }
  },
  {
    "id": "SR-B6-RENNEN-V01",
    "module": "SpellingRegel",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "skill": "klanken_spelling",
    "subSkill": "korte_klank",
    "familyId": "SR-KORTE-KLANK-GESLOTEN",
    "conceptId": "closed_syllable_double_consonant",
    "variantIndex": 3,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["rennen", "renen", "rennenn", "reenen"],
    "correctAnswer": 0,
    "explanation": "Korte klank (ren-nen): de 'e' is kort, dus de medeklinker 'n' verdubbelt.",
    "distractorExplanations": {
      "1": "'Renen' zou een lange 'e' geven (re-nen). De 'e' is kort, dus dubbele 'n'.",
      "2": "Alleen de medeklinker verdubbelt. Drie n's is te veel.",
      "3": "De klinker verdubbelt niet — de medeklinker verdubbelt. De 'e' is juist kort."
    }
  },
  {
    "id": "SR-B6-BED-V01",
    "module": "SpellingRegel",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "skill": "klanken_spelling",
    "subSkill": "eind_d_t",
    "familyId": "SR-EIND-D-T",
    "conceptId": "final_d_t_check",
    "variantIndex": 3,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["bed", "bet", "bedd", "bedt"],
    "correctAnswer": 0,
    "explanation": "Maak het langer: bedden. Je hoort een 'd', dus schrijf je 'bed' met een 'd'.",
    "distractorExplanations": {
      "1": "Maak het langer: bed-den. Je hoort een 'd', dus het is 'bed', niet 'bet'.",
      "2": "Geen dubbele 'd' aan het eind van een woord.",
      "3": "'Bedt' bestaat niet. Het is gewoon 'bed'."
    }
  },
  {
    "id": "SR-B6-NEVEN-V01",
    "module": "SpellingRegel",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "skill": "klanken_spelling",
    "subSkill": "v_f_wissel",
    "familyId": "SR-V-F-WISSEL",
    "conceptId": "v_f_alternation",
    "variantIndex": 3,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: twee ...",
    "options": ["neven", "nefen", "neffen", "nevven"],
    "correctAnswer": 0,
    "explanation": "'Neef' eindigt op een 'f'. In het meervoud wordt de 'f' een 'v': neven. Dezelfde regel als bij lief → lieve.",
    "distractorExplanations": {
      "1": "De 'f' verandert in een 'v'. Neef → neven, net als lief → lieve.",
      "2": "Geen dubbele 'f'. De 'f' verandert in een 'v'.",
      "3": "Geen dubbele 'v'. Eén 'v' is genoeg: neven."
    }
  },
  {
    "id": "SR-B6-MATEN-V01",
    "module": "SpellingRegel",
    "difficulty": 101,
    "difficultyTier": 1,
    "levelCode": "B6",
    "group": 6,
    "skill": "klanken_spelling",
    "subSkill": "lange_klank",
    "familyId": "SR-LANGE-KLANK-OPEN",
    "conceptId": "open_syllable_single_vowel",
    "variantIndex": 4,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["maten", "matten", "maaten", "mattenn"],
    "correctAnswer": 0,
    "explanation": "Maten (meervoud van maat): lange 'a' in een open lettergreep (ma-ten). Eén 'a', één 't'. Let op: 'matten' is het meervoud van 'mat' (korte 'a')!",
    "distractorExplanations": {
      "1": "'Matten' is het meervoud van 'mat' (korte 'a', gesloten lettergreep). 'Maten' heeft een lange 'a'.",
      "2": "In een open lettergreep schrijf je maar één klinker. Geen dubbele 'a'.",
      "3": "'Matten' is een ander woord, en 'nn' aan het eind is altijd fout."
    }
  }
]